import type { LPSettlementBatchStatusEnum } from '@talos/kyoko';
import { Box, EllipsisBoxWithTooltip, Icon } from '@talos/kyoko';
import { memo, type ReactNode } from 'react';
import type { DefaultTheme } from 'styled-components';
import { getLPBatchStatusMapping } from '../utils/lpBatchStatusMapping';

interface LPBatchStatusRendererProps {
  theme: DefaultTheme;
  status: LPSettlementBatchStatusEnum;
}

export const LPBatchStatusRenderer = memo(({ theme, status }: LPBatchStatusRendererProps) => {
  const statusMapping = getLPBatchStatusMapping(status, theme);

  // If no status mapping, just show the raw status with empty space for icon
  if (!statusMapping) {
    return null;
  }

  const prefix: ReactNode = statusMapping.icon ? (
    <Icon icon={statusMapping.icon} size={16} color={statusMapping.color} />
  ) : (
    <Box w="12px" flex="0 0 auto" />
  );

  return (
    <EllipsisBoxWithTooltip prefixNode={prefix} tooltipProps={{ placement: 'bottom-start' }}>
      {statusMapping.label}
    </EllipsisBoxWithTooltip>
  );
});

LPBatchStatusRenderer.displayName = 'LPBatchStatusRenderer';
